import ApolloClient from "apollo-boost";
import { createClient } from "graphql-ws";
import store from "../store";
/* import lodash from "lodash";
import change_theme from "../apollo/users/changed_theme.gql"; */

let shouldRefreshToken = false;
let _web_url = process.env.VUE_APP_GRAPHQL_IMS_SERVER_SUBSCRIPTIONS;

if (process.env.NODE_ENV == "production") {
  const _socket = new WebSocket(process.env.VUE_APP_GRAPHQL_IMS_SERVER_SUBSCRIPTIONS);
  _web_url = _socket.url;
}

export const SubscriptionClient = createClient({
  url: _web_url,
  connectionParams: async () => {
    if (shouldRefreshToken) {
      shouldRefreshToken = false;
    }
    return { authorization: localStorage?.getItem("token") };
  },
  on: {
    closed: (event) => {
      if (event.code === 1006) shouldRefreshToken = true;
    }
  }
});

const apolloClient = new ApolloClient({
  uri: process.env.VUE_APP_GRAPHQL_IMS_SERVER_URI,
  fetchOptions: {
    credentials: "include"
  },
  request: (operation) => {
    if (!localStorage.token) {
      localStorage.setItem("token", "");
    }
    operation.setContext({
      headers: {
        Authorization: localStorage.getItem("token")
      }
    });
  },
  onError: ({ graphQLErrors }) => {
    if (graphQLErrors) {
      for (let err of graphQLErrors) {
        if (err.code === "UNAUTHENTICATED") {
          store.dispatch("auth/logoutUser");
        } else {
          store.dispatch("layout/graphqlError", err.message);
        }
      }
    }
  }
});

apolloClient.defaultOptions = {
  query: {
    fetchPolicy: "no-cache"
  }
};

export default apolloClient;
